import { render, staticRenderFns } from "./ResearchVerify.vue?vue&type=template&id=4e69d343"
import script from "./ResearchVerify.vue?vue&type=script&lang=js"
export * from "./ResearchVerify.vue?vue&type=script&lang=js"
import style0 from "./ResearchVerify.vue?vue&type=style&index=0&id=4e69d343&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports